import { hideHeaderFooterPaths, paths } from '@/constants/paths';
import { pathMatchIgnoreLocale } from '@/ui/utils/localization-helpers/localization';
import { extractComponentFromChunk } from '@/ui/utils/tiles';
import {
  appendQueryStringToUrl,
  buildQueryStringFromPropertiesTable,
} from '@/utils/url-helper';

export function shouldHideHeaderOnPage(currentPath: string) {
  if (
    pathMatchIgnoreLocale(currentPath, paths.checkout) ||
    pathMatchIgnoreLocale(currentPath, paths.usLandingPage) ||
    hideHeaderFooterPaths.some((path) => pathMatchIgnoreLocale(currentPath, path))
  ) {
    return true;
  }

  return false;
}

export function resolveLinkUrlFromChunk(
  link: any,
  localizedLinkFn: (path: string) => string,
): string | undefined {
  const internalLinkContent =
    extractComponentFromChunk(link, 'link', 'ItemRelationsContent' as never) ??
    extractComponentFromChunk(link, 'internal-link', 'ItemRelationsContent' as never);
  const internalLinkPath = (internalLinkContent as any)?.items?.[0]?.path;

  const externalLinkContent = extractComponentFromChunk(
    link,
    'external-link',
    'SingleLineContent' as never,
  );
  const externalLink = (externalLinkContent as any)?.text;

  const linkPath = externalLink || internalLinkPath;
  if (!linkPath) {
    return undefined;
  }

  const resolvedHref = externalLink || localizedLinkFn(internalLinkPath);

  const urlParamsSections = extractComponentFromChunk(
    link,
    'url-parameters',
    'PropertiesTableContent' as never,
  ) as { sections?: unknown } | undefined;
  const queryString = buildQueryStringFromPropertiesTable(
    urlParamsSections?.sections as Parameters<typeof buildQueryStringFromPropertiesTable>[0],
  );

  return appendQueryStringToUrl(resolvedHref, queryString);
}
